/* global axios */
// import ApiClient from './ApiClient';
import CacheEnabledApiClient from './CacheEnabledApiClient';

export class IssuesAPI extends CacheEnabledApiClient {
  constructor() {
    super('issues', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'issue';
  }

  // eslint-disable-next-line class-methods-use-this
  extractDataFromResponse(response) {
    return response.data;
  }

  // eslint-disable-next-line class-methods-use-this
  marshallData(dataToParse) {
    return { data: dataToParse };
  }

  getAgents({ issueId }) {
    return axios.get(`${this.url}/${issueId}/issue_members`);
  }

  addAgents({ issueId, agentsList }) {
    return axios.post(`${this.url}/${issueId}/issue_members`, {
      user_ids: agentsList,
    });
  }

  updateAgents({ issueId, agentsList }) {
    return axios.patch(`${this.url}/${issueId}/issue_members`, {
      user_ids: agentsList,
    });
  }
}

export default new IssuesAPI();
